import { createSelector } from 'reselect';
import { stateName } from './constants';

const localState = state => state[stateName];

export const getSearchesState = createSelector(localState, _ref => {
  let {
    searches
  } = _ref;
  return searches;
});
export const getSearchesById = createSelector(getSearchesState, _ref2 => {
  let {
    byId
  } = _ref2;
  return byId;
});
export const getSearchIds = createSelector(getSearchesState, _ref3 => {
  let {
    ids
  } = _ref3;
  return ids;
});
export const getSearches = createSelector(getSearchIds, getSearchesById, (ids, byId) => ids.map(id => byId[id]));
export const getSubscribedSearchIds = createSelector(getSearches, searches => {
  const subscribedSearches = searches.filter(_ref4 => {
    let {
      subscribed
    } = _ref4;
    return subscribed;
  });
  if (!subscribedSearches) return null;
  return subscribedSearches.map(_ref5 => {
    let {
      id
    } = _ref5;
    return id;
  });
});
export const getRecentSearchIds = createSelector(getSearches, searches => {
  const recentSearches = searches.filter(_ref6 => {
    let {
      subscribed
    } = _ref6;
    return !subscribed;
  });
  if (!recentSearches) return null;
  return recentSearches.map(_ref7 => {
    let {
      id
    } = _ref7;
    return id;
  });
});
export const getCurrentSearchId = state => localState(state).currentSearchId;
export const getIsSubscribedModalOpen = state => localState(state).isSubscribeModalOpen;
export const getSearchById = (state, id) => {
  if (!id) return null;
  return localState(state).searches.byId[id];
};
export const getCurrentSearch = state => getSearchById(state, getCurrentSearchId(state));